// extracted by mini-css-extract-plugin
export default {"mainDiv":"homeTitle_mainDiv__n633o","topHr":"homeTitle_topHr__uUQgq","bottomHr":"homeTitle_bottomHr__4xdGN","title":"homeTitle_title__PzeKy"};